var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebooklmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.979 66.987C114.603 66.987 0 183.21 0 326.657v124.33h47.19v-12.373c0-58.198 46.463-105.345 103.807-105.345s103.808 47.147 103.808 105.323v12.395h47.19v-12.373c0-84.63-67.627-153.174-150.998-153.174a148.64 148.64 0 00-87.168 28.117C89.6 261.59 142.656 225.92 203.947 225.92c86.55 0 156.736 71.21 156.736 158.998v66.069h47.19v-66.07c0-114.24-91.308-206.89-203.948-206.89a201.461 201.461 0 00-132.629 49.75c35.03-67.18 104.576-112.94 184.704-112.94 115.328 0 208.81 94.848 208.81 211.84v124.31H512v-124.33C511.98 183.21 397.376 66.986 255.98 66.986z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebooklmIcon);
export default __webpack_public_path__ + "static/media/notebooklm-icon.892f6a70d7a3442657a28576492c4177.svg";
export { ForwardRef as ReactComponent };